import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

export const exportToPDF = (data) => {
  const doc = new jsPDF();
  doc.text("Export des Produits", 14, 10);
  autoTable(doc, { head: [["Code ISIN", "Nom", "Société", "Type", "Risque"]], body: data.map((p) => [p.code_isin, p.nom_produit, p.societe_gestion, p.type, p.risque]) });
  doc.save("produits_export.pdf");
};

export const exportToExcel = (data) => {
  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Produits");
  XLSX.writeFile(workbook, "produits_export.xlsx");
};
